import { render, staticRenderFns } from "./ReviseAdd.vue?vue&type=template&id=48ba04c4&scoped=true"
import script from "./ReviseAdd.vue?vue&type=script&lang=js"
export * from "./ReviseAdd.vue?vue&type=script&lang=js"
import style0 from "./ReviseAdd.vue?vue&type=style&index=0&id=48ba04c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba04c4",
  null
  
)

export default component.exports